import * as types from './actionTypes';

export function setUnResolvedBannerStatus(unResolvedBannerStatus) {
  return { type: types.SET_UNRESOLVED_BANNER_STATUS, unResolvedBannerStatus };
}
